module.exports = __webpack_public_path__ + "img/ren.27caf628.png";